<template>
    <div class="container mx-auto px-4" v-if="response">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">Pipacs Pékség - {{ __('Fizetés') }}</h1>
        <p class="bg-emerald-100 border border-emerald-200 font-bold mb-8 mx-auto p-2 rounded table text-emerald-500"
           v-if="response.e === 'SUCCESS'"
        >
            {{ __('Sikeres fizetés') }}
        </p>
        <p class="bg-amber-100 border border-amber-200 font-bold mb-8 mx-auto p-2 rounded table text-amber-500"
           v-if="response.e === 'CANCEL'"
        >
            {{ __('Megszakítottad a fizetést') }}
        </p>
        <p class="bg-amber-100 border border-amber-200 font-bold mb-8 mx-auto p-2 rounded table text-amber-500"
           v-if="response.e === 'TIMEOUT'"
        >
            {{ __('Túllépted a tranzakció elindításának lehetséges maximális idejét.') }}
        </p>
        <p class="bg-red-100 border border-red-200 font-bold mb-8 mx-auto p-2 rounded table text-red-500"
           v-if="response.e === 'FAIL'"
        >
            {{ __('Sikertelen fizetés') }}
        </p>
        <p class="mb-2 text-center">{{ __('SimplePay tranzakció azonosító') }}:</p>
        <p class="bg-white border border-slate-300 font-bold mb-8 mx-auto p-2 rounded table text-slate-600">
            {{ response.t }}
        </p>
    </div>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import { useRequestStore } from '../../stores/request';

    const requestStore = useRequestStore();
    const response = ref();

    onMounted(async () => {
        const params = new URLSearchParams(window.location.search);
        const encoded = params.get('r');

        response.value = JSON.parse(atob(encoded));

        requestStore.put('payments/process/' + response.value.o, {
            status: response.value.e,
            transaction_id: response.value.t,
        });
    });
</script>
